<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-11 col-sm-12 col-xs-12">
      <NuvemList :botaoNovo="false" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NuvemList from "../../../../_shared/features/NuvemList.vue";

export default {
  name: "NuvensAdmin",
  components: { NuvemList },
  data() {
    return {};
  },
  methods: {},
};
</script>
